export const LADE_FINANZ_INFORMATIONEN = "ladeFinanzInformationen";
